var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "login-container" },
        [
          _c(
            "el-form",
            {
              ref: "loginForm",
              staticClass: "login-form",
              attrs: {
                model: _vm.loginForm,
                rules: _vm.loginRules,
                autocomplete: "on",
                "label-position": "left",
              },
            },
            [
              _c("div", { staticClass: "title-container" }, [
                _c("h3", { staticClass: "title" }, [
                  _vm._v(
                    "\n            " + _vm._s(_vm.systemName) + "\n          "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticStyle: { "margin-bottom": "30px" },
                  attrs: { prop: "username" },
                },
                [
                  _c(
                    "span",
                    { staticClass: "svg-container" },
                    [_c("svg-icon", { attrs: { "icon-class": "user" } })],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-input", {
                    ref: "username",
                    attrs: {
                      placeholder: _vm.$t("login.username"),
                      name: "username",
                      type: "text",
                      tabindex: "1",
                      autocomplete: "on",
                    },
                    model: {
                      value: _vm.loginForm.username,
                      callback: function ($$v) {
                        _vm.$set(_vm.loginForm, "username", $$v)
                      },
                      expression: "loginForm.username",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tooltip",
                {
                  attrs: {
                    content: "Caps lock is On",
                    placement: "right",
                    manual: "",
                  },
                  model: {
                    value: _vm.capsTooltip,
                    callback: function ($$v) {
                      _vm.capsTooltip = $$v
                    },
                    expression: "capsTooltip",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "password" } },
                    [
                      _c(
                        "span",
                        { staticClass: "svg-container" },
                        [
                          _c("svg-icon", {
                            attrs: { "icon-class": "password" },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("el-input", {
                        key: _vm.passwordType,
                        ref: "password",
                        attrs: {
                          type: _vm.passwordType,
                          placeholder: _vm.$t("login.password"),
                          name: "password",
                          tabindex: "2",
                          autocomplete: "on",
                        },
                        on: {
                          blur: function ($event) {
                            _vm.capsTooltip = false
                          },
                        },
                        nativeOn: {
                          keyup: [
                            function ($event) {
                              return _vm.checkCapslock($event)
                            },
                            function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleLogin($event)
                            },
                          ],
                        },
                        model: {
                          value: _vm.loginForm.password,
                          callback: function ($$v) {
                            _vm.$set(_vm.loginForm, "password", $$v)
                          },
                          expression: "loginForm.password",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "show-pwd", on: { click: _vm.showPwd } },
                        [
                          _c("svg-icon", {
                            attrs: {
                              "icon-class":
                                _vm.passwordType === "password"
                                  ? "eye"
                                  : "eye-open",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticStyle: { color: "white", "font-size": "14px" },
                  on: { click: _vm.forgetPass },
                },
                [_vm._v(_vm._s(_vm.$t("login.resetPass")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticStyle: {
                    width: "100%",
                    "margin-top": "30px",
                    "margin-bottom": "30px",
                  },
                  attrs: {
                    loading: _vm.loading,
                    type: "primary",
                    disabled: _vm.buttonDisabled,
                  },
                  nativeOn: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.handleLogin($event)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("login.logIn")) +
                      "\n        "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            width: "600px",
            "close-on-click-modal": false,
            visible: _vm.modifyPassDialogVisible,
            title: _vm.$t("navbar.modifyPass"),
          },
          on: {
            "update:visible": function ($event) {
              _vm.modifyPassDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { ref: "form", attrs: { "label-width": "120px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("navbar.newPass") } },
                [
                  _c("el-input", {
                    attrs: { "show-password": "" },
                    model: {
                      value: _vm.newPass1,
                      callback: function ($$v) {
                        _vm.newPass1 = $$v
                      },
                      expression: "newPass1",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("navbar.newPass2") } },
                [
                  _c("el-input", {
                    attrs: { "show-password": "" },
                    model: {
                      value: _vm.newPass2,
                      callback: function ($$v) {
                        _vm.newPass2 = $$v
                      },
                      expression: "newPass2",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.modifyPassDialogVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("button.cancel")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmModifyPass },
                },
                [_vm._v(_vm._s(_vm.$t("button.confirm")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }